import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatRadioChange} from '@angular/material/radio';
import {PatientService} from '../../../patient/patient.service';
import {Globals} from '../../../../globals';
import {UntypedFormControl, Validators} from '@angular/forms';
import {MyErrorStateMatcher} from '../report-aging-filter/report-aging-filter.component';
import {TreatmentPlanningDataModel} from '../../../treatment-planning/models/treatment-planning-data.model';
import {TreatmentPlanningService} from '../../../treatment-planning/treatment-planning.service';
import {TdoDropdownChange} from '../../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ReportFrontDeskFilterModel} from '../../models/ReportFrontDeskFilterModel.model';

@Component({
  selector: 'app-report-front-desk-filters',
  templateUrl: './report-front-desk-filters.component.html',
  styleUrls: ['./report-front-desk-filters.component.scss']
})
export class ReportFrontDeskFiltersComponent implements OnInit {
  // isEnvelop: boolean;
  // isTreatmentPlan: boolean;
  PatientContactsList: any;
  selectedContact: any;
  ReferringDoctorList: any;
  selectedReferringDoctor: any;
  envelopFor: string = 'Patient';
  envelopSize: string = 'Regular';

  listOfParentTreatmentPlans: TreatmentPlanningDataModel[];
  listOfOptionTreatmentPlans: TreatmentPlanningDataModel[];
  selectedParentTreatmentPlan: TreatmentPlanningDataModel;
  selectedOptionTreatmentPlan: TreatmentPlanningDataModel;
  ParametersFrontDeskFilters: ReportFrontDeskFilterModel;
  // parametersTreatmentPlan: ReportFrontDeskTreatmentFilterModel;
  // reportID_FrontDesk_Envelops: string = '9000000A-1000-0000-0000-000000000013';
  // reportID_FrontDesk_TreatmentPlan: string = '9000000A-1000-0000-0000-000000000014';

  @Output() newItemEvent = new EventEmitter<any>();
  @Input() isEnvelop = false;
  @Input() isTreatmentPlan = false;

  constructor(public patientService: PatientService,
              private globals: Globals,
              private treatmentPlanningService: TreatmentPlanningService,
              private snackBar: MatSnackBar) { }

  referringSelected = new UntypedFormControl('valid', [Validators.required]);
  matcher = new MyErrorStateMatcher();

  ngOnInit(): void {
    this.setComponentFilter();
  }
  setComponentFilter(){
    this.patientService.getPatientContactsTypeById(this.globals.currentPatientId).subscribe(data => {
      this.PatientContactsList = data;
    }, err => {
      console.log(err);
    });

    this.patientService.getPatientAllReferringDoctor(this.globals.currentPatientId).subscribe((res) => {
      // this.patientReferringDoctor = res;
      this.ReferringDoctorList = res;
    });
    this.treatmentPlanningService.getTreatmentOptionPlan(this.globals.currentPatientId).subscribe((data) => {
      this.listOfParentTreatmentPlans = data;
    }, err => {
      console.log(err);
      this.createAlertMessage('Error', 'Something went wrong', 5000);
    });
   }

  radioChange(event: MatRadioChange) {
    this.envelopFor = event.value;
  }

  radioSizeChange(event: MatRadioChange) {
    this.envelopSize = event.value;
   }

  onChangeContact(event) {
    this.selectedContact = event.value;
  }

  onChangeReferringDoctor(event: any) {
    if (event.isUserInput){
        this.selectedReferringDoctor = event.value;
    }
  }

  onSelectedTreatmentPlanChange(event: TdoDropdownChange) {
    this.selectedParentTreatmentPlan = event.value;
    this.listOfOptionTreatmentPlans = this.selectedParentTreatmentPlan.dataTreatmentPlanning1;
    this.selectedOptionTreatmentPlan = this.listOfOptionTreatmentPlans[0];
  }

  onSelectedTreatmentOptionPlanChange(event: TdoDropdownChange) {
    this.selectedOptionTreatmentPlan = event.value;
  }

  


  sendFilterToParent(){
    this.ParametersFrontDeskFilters = new  ReportFrontDeskFilterModel();
    if (this.isEnvelop === true)
    {
      // check filter Envelop For
      if (this.envelopFor === undefined || this.envelopSize === undefined){
        this.createAlertMessage('Please select all options', 'Error');
        return;
      }
      if (this.envelopFor === 'Contact' && this.selectedContact === undefined) {

        this.createAlertMessage('Please select Contact', 'Error');
        return;

      }
      if (this.envelopFor === 'Referring' && this.selectedReferringDoctor === undefined) {

        this.createAlertMessage('Please select Referring Doctor', 'Error');
        return;
      }
      this.ParametersFrontDeskFilters.PatientId = this.globals.currentPatientId;
      this.ParametersFrontDeskFilters.size = this.envelopSize;
      this.ParametersFrontDeskFilters.envelopFor = this.envelopFor;
      if (this.envelopFor === 'Contact')
      {
        this.ParametersFrontDeskFilters.ContactId = this.selectedContact.ContactId;
      }
      else if (this.envelopFor === 'Referring')
      {
        this.ParametersFrontDeskFilters.ContactId = this.selectedReferringDoctor.ContactId;
      }
      this.newItemEvent.emit(this.ParametersFrontDeskFilters);
    }
    else if (this.isTreatmentPlan === true)
    {
      // check selected Treatment Plan
      if (this.selectedParentTreatmentPlan === undefined || this.selectedOptionTreatmentPlan === undefined)
      {
        this.createAlertMessage('Please select Treatment Plan', 'Error');
        return;
      }
      this.ParametersFrontDeskFilters.PatientId = this.globals.currentPatientId;
      this.ParametersFrontDeskFilters.ParentTreatmentPlanningID = this.selectedParentTreatmentPlan.TreatmentPlanningID;
      this.ParametersFrontDeskFilters.TreatmentPlanningID = this.selectedOptionTreatmentPlan.TreatmentPlanningID;
      this.newItemEvent.emit(this.ParametersFrontDeskFilters);
    }
  }

  createAlertMessage(type: string, message: string, duration: number = 3000) {
    this.snackBar.open(message, type, {
      duration,
      verticalPosition: 'top'
    });
  }


}


